/*
    Add here your own custom javascript
*/

// Fix for the RTL language in the demo
document.querySelectorAll('[href="/ar"]').forEach(link => {
    link.setAttribute('target', '_blank')
})

// EcomGraduates - Affiliate tracking code
function addRefParamToUrlsAndSetCookie () {
  const urlParams = new URLSearchParams(window.location.search)
  let refParam = urlParams.get('ref')
  if (!refParam) {
    const cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim()
      if (cookie.startsWith('ref=')) {
        refParam = cookie.substring(4)
        urlParams.set('ref', refParam)
        break
      }
    }
  }
  if (refParam) {
    document.cookie = `ref=${refParam}; expires=${new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)}; path=/`
    const links = document.getElementsByTagName('a')
    for (let i = 0; i < links.length; i++) {
      const link = links[i]
      const url = new URL(link.href)
      if (url.hostname === 'ecomgraduates.com') {
        if (url.search) { url.search += `&ref=${refParam}` } else { url.search = `?ref=${refParam}` }
        link.href = url.href
      }
    }
  }
}

// =====================================================
// Koabz - Cloudinary Upload for Large Files
// =====================================================
(function() {
  var CLOUD_NAME = 'n98mo0ce';
  var UPLOAD_PRESET = 'koabz_upload';

  document.addEventListener('DOMContentLoaded', function() {
    patchDropZones();
  });

  function uploadToCloudinary(file, onProgress) {
    return new Promise(function(resolve, reject) {
      var fd = new FormData();
      fd.append('file', file);
      fd.append('upload_preset', UPLOAD_PRESET);
      fd.append('folder', 'koabz');
      var xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://api.cloudinary.com/v1_1/' + CLOUD_NAME + '/auto/upload');
      xhr.upload.onprogress = function(e) {
        if (e.lengthComputable && onProgress) onProgress(Math.round(e.loaded / e.total * 100));
      };
      xhr.onload = function() {
        xhr.status === 200 ? resolve(JSON.parse(xhr.responseText).secure_url) : reject();
      };
      xhr.onerror = function() { reject(); };
      xhr.send(fd);
    });
  }

  function patchDropZones() {
    document.querySelectorAll('.js-validate-file-group').forEach(function(wrapper) {
      var fi = wrapper.querySelector('.js-main-file-input');
      if (!fi || fi.dataset.cloudinaryPatched) return;
      fi.dataset.cloudinaryPatched = 'true';

      // أضف progress bar
      var pb = document.createElement('div');
      pb.style.cssText = 'margin-top:8px;display:none;';
      pb.innerHTML = '<div style="background:#e9ecef;border-radius:4px;height:6px;"><div class="cld-bar" style="background:#28a745;height:100%;width:0%;transition:width 0.3s;border-radius:4px;"></div></div><p class="cld-txt" style="font-size:12px;color:#666;margin:4px 0 0;text-align:center;">جاري الرفع...</p>';
      var dz = wrapper.querySelector('.js-drop-zone');
      if (dz) dz.after(pb);

      fi.addEventListener('change', function(e) {
        var files = Array.from(e.target.files).filter(function(f) { return f.size > 5 * 1024 * 1024; });
        if (!files.length) return;
        e.stopImmediatePropagation();
        fi.value = '';

        pb.style.display = 'block';
        var bar = pb.querySelector('.cld-bar');
        var txt = pb.querySelector('.cld-txt');
        var hi = wrapper.querySelector('.js-hidden-inputs-container');
        var fl = wrapper.querySelector('.js-files-list');

        Promise.all(files.map(function(file) {
          return uploadToCloudinary(file, function(pct) {
            if (bar) bar.style.width = pct + '%';
            if (txt) txt.textContent = 'جاري الرفع... ' + pct + '%';
          }).then(function(url) {
            if (hi) {
              var inp = document.createElement('input');
              inp.type = 'hidden';
              inp.name = (wrapper.getAttribute('data-label') || 'attachment') + '[' + (hi.children.length + 1) + ']';
              inp.value = url;
              hi.appendChild(inp);
            }
            if (fl) {
              var item = document.createElement('div');
              item.className = 'file-item';
              item.style.cssText = 'display:flex;align-items:center;justify-content:space-between;padding:8px 12px;background:#fff;border:1px solid #e0e0e0;border-radius:6px;margin-top:4px;';
              item.innerHTML = '<span style="font-size:13px">' + file.name + ' <small style="color:#888">(' + (file.size / 1024 / 1024).toFixed(1) + ' MB)</small></span><span style="color:#28a745;font-size:12px">تم ✓</span>';
              fl.appendChild(item);
            }
          }).catch(function() {
            alert('فشل رفع: ' + file.name);
          });
        })).then(function() { pb.style.display = 'none'; });

      }, true);
    });
  }
})();